import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { clientApi } from "../apis/clientApi";
import { authApi } from "../apis/authApi";

const initialState = {
    Flag: false,
    Bussiness: [],
    WaitingList: [],
    Tickets: [],
    Subscriptions: [],
    currentBussinessIdx: null,
    currentScenarioIdx: null,
};

const clientSlice = createSlice({
    name: "client",
    initialState,
    reducers: {
        setCurrentBussiness: (state, { payload }) => {
            state.currentBussinessIdx = payload;
            const business = state.Bussiness[payload];
            state.currentScenarioIdx = Array.isArray(business?.scenarios) && business.scenarios.length > 0 ? 0 : -1;
        },
        setCurrentScenario: (state, { payload }) => {
            state.currentScenarioIdx = payload;
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(isAnyOf(authApi.endpoints.logout.matchFulfilled, authApi.endpoints.deleteAccount.matchFulfilled, authApi.endpoints.refreshToken.matchRejected), (state) => {
            state.Flag = false;
            state.Bussiness = [];
            state.WaitingList = [];
            state.currentBussinessIdx = null;
            state.currentScenarioIdx = null;
        })
        .addMatcher(clientApi.endpoints.fetchData.matchFulfilled, (state, { payload }) => {
            state.Flag = true;
            state.Bussiness = payload.Bussinesses || [];
            state.WaitingList = payload.WaitingList || [];
            state.currentBussinessIdx = Array.isArray(state.Bussiness) && state.Bussiness.length > 0 ? 0 : -1;
            
            const firstBusiness = state.Bussiness[0];
            state.currentScenarioIdx = Array.isArray(firstBusiness?.scenarios) && firstBusiness.scenarios.length > 0 ? 0 : null;
        })
        .addMatcher(clientApi.endpoints.refreshData.matchFulfilled, (state, { payload }) => {
            state.Bussiness = payload.Bussinesses || [];
            state.WaitingList = payload.WaitingList || [];
            state.currentBussinessIdx = Array.isArray(state.Bussiness) && state.Bussiness.length > 0 ? 0 : null;

            const firstBusiness = state.Bussiness[0];
            state.currentScenarioIdx = Array.isArray(firstBusiness?.scenarios) && firstBusiness.scenarios.length > 0 ? 0 : null;
        })
        .addMatcher(clientApi.endpoints.onboarding.matchFulfilled, (state, { payload }) => {
            state.Bussiness = payload || [];
            state.currentBussinessIdx = Array.isArray(state.Bussiness) && state.Bussiness.length > 0 ? 0 : null;

            const firstBusiness = state.Bussiness[0];
            state.currentScenarioIdx = Array.isArray(firstBusiness?.scenarios) && firstBusiness.scenarios.length > 0 ? 0 : null;
        })
        .addMatcher(clientApi.endpoints.createTicket.matchFulfilled, (state, { payload }) => {
            state.Tickets.push(payload);
        })
        .addMatcher(clientApi.endpoints.replyTicket.matchFulfilled, (state, { payload }) => {
            const ticketIndex = state.Tickets.findIndex(ticket => ticket.TIC_ID === payload.TIC_ID);
            if (ticketIndex !== -1) {
                const existingReplies = state.Tickets[ticketIndex].replies || [];
                state.Tickets[ticketIndex] = { 
                    ...state.Tickets[ticketIndex], 
                    replies: [...existingReplies, payload.Reply] 
                };
            }
        })
        .addMatcher(clientApi.endpoints.createBussiness.matchFulfilled, (state, { payload }) => {
            state.Bussiness.push(payload);
            state.currentBussinessIdx = state.Bussiness.length - 1;

            state.currentScenarioIdx = null;
        })
        .addMatcher(clientApi.endpoints.updateBussiness.matchFulfilled, (state, { payload }) => {
            if (state.currentBussinessIdx !== null) {
                const currentBusiness = state.Bussiness[state.currentBussinessIdx];
                if (currentBusiness) {
                    Object.assign(currentBusiness, {
                        BUS_Name: payload.BUS_Name,
                        BUS_Description: payload.BUS_Description,
                        BUS_Stage: payload.BUS_Stage,
                        BUS_Class: payload.BUS_Class,
                        BUS_Country: payload.BUS_Country,
                        BUS_State: payload.BUS_State,
                    });
                }
            }
        })
        .addMatcher(isAnyOf(clientApi.endpoints.deleteBussiness.matchFulfilled, clientApi.endpoints.InvokeCollaboration.matchFulfilled), (state, { payload }) => {
            const deletedBusinessId = payload;
            state.Bussiness = state.Bussiness.filter((business) => business.BUS_ID !== deletedBusinessId);

            if (state.currentBussinessIdx !== null) {
                const currentBusiness = state.Bussiness[state.currentBussinessIdx];
                if (!currentBusiness || currentBusiness.BUS_ID === deletedBusinessId) {
                    state.currentBussinessIdx = Array.isArray(state.Bussiness) && state.Bussiness.length > 0 ? 0 : null;

                    const newCurrentBusiness = state.Bussiness[0];
                    state.currentScenarioIdx = Array.isArray(newCurrentBusiness?.scenarios) && newCurrentBusiness.scenarios.length > 0 ? 0 : null;
                }
            }
        })
        .addMatcher(clientApi.endpoints.createScenario.matchFulfilled, (state, { payload }) => {
            if (state.currentBussinessIdx !== null) {
                const currentBusiness = state.Bussiness[state.currentBussinessIdx];
                if (currentBusiness) {
                    if (!currentBusiness.scenarios) {
                        currentBusiness.scenarios = [];
                    }
                    currentBusiness.scenarios.push(payload);
                    state.currentScenarioIdx = currentBusiness.scenarios.length - 1;
                }
            }
        })
        .addMatcher(clientApi.endpoints.updateScenario.matchFulfilled, (state, { payload }) => {
            if (state.currentBussinessIdx !== null && state.currentScenarioIdx !== null) {
                const currentBusiness = state.Bussiness[state.currentBussinessIdx];
                const currentScenario = currentBusiness?.scenarios?.[state.currentScenarioIdx];
                
                if (currentScenario) {
                    Object.assign(currentScenario, {
                        SCE_Name: payload.SCE_Name,
                        SCE_StartDate: payload.SCE_StartDate,
                        SCE_Duration: payload.SCE_Duration,
                    });
                }
            }
        })
        .addMatcher(clientApi.endpoints.deleteScenario.matchFulfilled, (state, { payload }) => {
            if (state.currentBussinessIdx !== null) {
                const currentBusiness = state.Bussiness[state.currentBussinessIdx];
                if (currentBusiness?.scenarios) {
                    const deletedScenarioId = payload?.Data || payload;
                    currentBusiness.scenarios = currentBusiness.scenarios.filter((scenario) => scenario.SCE_ID !== deletedScenarioId);

                    if (state.currentScenarioIdx !== null) {
                        const currentScenario = currentBusiness.scenarios[state.currentScenarioIdx];
                        if (!currentScenario || currentScenario.SCE_ID === deletedScenarioId) {
                            state.currentScenarioIdx = Array.isArray(currentBusiness.scenarios) && currentBusiness.scenarios.length > 0 ? 0 : null;
                        }
                    }
                }
            }
        })
        .addMatcher(clientApi.endpoints.addCollaborator.matchFulfilled, (state, { payload }) => {
            if (state.currentBussinessIdx !== null) {
                const currentBusiness = state.Bussiness[state.currentBussinessIdx];

                if (currentBusiness) {
                    if (!currentBusiness.Collaborators) {
                        currentBusiness.Collaborators = [];
                    }

                    const existingCollaborator = currentBusiness.Collaborators.find(
                        collaborator => collaborator.USR_EMAIL === payload.USR_EMAIL
                    );

                    if (!existingCollaborator) {
                        currentBusiness.Collaborators.push(payload);
                    }
                }
            }
        })
        .addMatcher(clientApi.endpoints.removeCollaborator.matchFulfilled, (state, { payload }) => {
            if (state.currentBussinessIdx !== null) {
                const currentBusiness = state.Bussiness[state.currentBussinessIdx];
                
                if (currentBusiness && currentBusiness.Collaborators) {
                    const collaboratorEmail = payload.USR_EMAIL || payload;
                    currentBusiness.Collaborators = currentBusiness.Collaborators.filter(
                        (collaborator) => collaborator.USR_EMAIL !== collaboratorEmail
                    );
                }
            }
        });
        builder.addMatcher(clientApi.endpoints.AcceptInvitation.matchFulfilled, (state, { payload }) => {
            state.Bussiness.push(payload);
            state.currentBussinessIdx = state.Bussiness.length - 1;

            const newBusiness = state.Bussiness[state.currentBussinessIdx];
            state.currentScenarioIdx = Array.isArray(newBusiness?.scenarios) && newBusiness.scenarios.length > 0 ? 0 : null;
            state.WaitingList = state.WaitingList.filter((item) => item.BUS_ID !== payload.BUS_ID);
        });
        builder.addMatcher(clientApi.endpoints.RejectInvitation.matchFulfilled, (state, { payload }) => {
            state.WaitingList = state.WaitingList.filter((item) => item.BUS_ID !== payload);
        });
        builder.addMatcher(clientApi.endpoints.StoreResponses.matchFulfilled, (state, { payload }) => {
            if (state.currentBussinessIdx !== null && state.currentScenarioIdx !== null) {
                const currentScenario = state.Bussiness[state.currentBussinessIdx]?.scenarios?.[state.currentScenarioIdx];
                
                if (currentScenario && payload.Status && typeof payload.Status === 'object') {
                    if (currentScenario.Status && typeof currentScenario.Status === 'object') {
                        Object.assign(currentScenario.Status, payload.Status);
                    } else {
                        currentScenario.Status = payload.Status;
                    }
                }
            }
        });
        builder.addMatcher(clientApi.endpoints.SubmitQuestionner.matchFulfilled, (state, { payload }) => {
            if (state.currentBussinessIdx !== null && state.currentScenarioIdx !== null) {
                const currentScenario = state.Bussiness[state.currentBussinessIdx]?.scenarios?.[state.currentScenarioIdx];
                
                if (currentScenario) {
                    if (payload.Reports) {
                        currentScenario.Reports = payload.Reports;
                    }

                    if (payload.Financials && typeof payload.Financials === 'object') {
                        const keys = Object.keys(payload.Financials);
                        const key = keys[0];
                        if (key) {
                            if (currentScenario.Financials && typeof currentScenario.Financials === 'object') {
                                currentScenario.Financials[key] = payload.Financials[key];
                            } else {
                                currentScenario.Financials = { [key]: payload.Financials[key] };
                            }
                        }
                    } 

                    if (payload.Status && typeof payload.Status === 'object') {
                        if (currentScenario.Status && typeof currentScenario.Status === 'object') {
                            Object.assign(currentScenario.Status, payload.Status);
                        } else {
                            currentScenario.Status = payload.Status;
                        }
                    }
                }
            }
        });
    },
});

export const { setCurrentBussiness, setCurrentScenario, logout } = clientSlice.actions;
export default clientSlice.reducer;
